"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
class Constants {
}
exports.Constants = Constants;
Constants.ENDPOINT = 'https://leetcode.com';
Constants.API_URL = `${Constants.ENDPOINT}/graphql`;
Constants.X_CSRFTOKEN_HEADER_KEY = 'x-csrftoken';
